// extracted by mini-css-extract-plugin
export default {"toggle":"TextStyleToggles_toggle__4y9xm"};